import { render, staticRenderFns } from "./ResubmitPartnerBankInfo.vue?vue&type=template&id=4d2335e2"
import script from "./ResubmitPartnerBankInfo.vue?vue&type=script&lang=js"
export * from "./ResubmitPartnerBankInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports